/**
 * Custom error classes for charge types API operations
 * These provide consistent error messages for Sentry grouping
 * while preserving context data for debugging
 */

import { BaseApiFetchError } from '../../utility/error/BaseApiFetchError'
import { BaseApiValidationError } from '../../utility/error/BaseApiValidationError'

export class ChargeTypesFetchError extends BaseApiFetchError {
  constructor(url: string, params: Record<string, any>, originalError: any) {
    super('charge-types', url, params, originalError)

    // Override name for backwards compatibility using Object.defineProperty like CustomError
    Object.defineProperty(this, 'name', {
      value: 'ChargeTypesFetchError',
      enumerable: true,
    })
  }
}

export class ChargeTypesValidationError extends BaseApiValidationError {
  constructor(
    url: string,
    params: Record<string, any>,
    rawResponse: any,
    originalError: any,
  ) {
    super('charge-types', url, params, rawResponse, originalError)

    // Override name for backwards compatibility using Object.defineProperty like CustomError
    Object.defineProperty(this, 'name', {
      value: 'ChargeTypesValidationError',
      enumerable: true,
    })
  }
}
